'use client';
import { isArray, isString } from '@s7/utils';

const escapeRegex = (value)=>{
    return value.replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&');
};
const highlighter = (value, _highlight)=>{
    if (_highlight == null) {
        return [
            {
                chunk: value,
                highlighted: false
            }
        ];
    }
    const highlight = isArray(_highlight) ? _highlight.map(escapeRegex) : escapeRegex(_highlight);
    const shouldHighlight = isArray(highlight) ? highlight.filter((part)=>part.trim().length > 0).length > 0 : highlight.trim() !== '';
    if (!shouldHighlight) {
        return [
            {
                chunk: value,
                highlighted: false
            }
        ];
    }
    const matcher = isString(highlight) ? highlight.trim() : highlight.filter((part)=>part.trim().length !== 0).map((part)=>part.trim()).join('|');
    const re = new RegExp(`(${matcher})`, 'gi');
    const chunks = value.split(re).map((part)=>({
            chunk: part,
            highlighted: re.test(part)
        })).filter(({ chunk })=>chunk);
    return chunks;
};

export { highlighter };
//# sourceMappingURL=highlighter.js.map
